import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { ToggleRegs } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/toggles`,
    response: {} as ToggleRegs.Get.Toggle[],
    method: HTTP_METHODS.GET,
  },
};
